import React from 'react';

import {MyAccount, PhoneMini, RulerMini} from '@optimaxdev/icons';

import * as MobileDesktop from './img/mobile-desktop.svg';

export const MOBILE_INSTRUMENTS = [
    {
        icon: MyAccount,
        iconWidth: 12,
        strokeWidth: 1.5,
        text: (
            <>
                Log in to
                <br />
                your account
            </>
        ),
        title: 'login',
    },
    {
        icon: RulerMini,
        iconWidth: 20,
        strokeWidth: 2,
        text: (
            <>
                10+ ft. of
                <br />
                well-lit space
            </>
        ),
        title: 'space',
    },
    {
        icon: PhoneMini,
        iconWidth: 12,
        strokeWidth: 1.5,
        text: (
            <>
                A mobile
                <br />
                device
            </>
        ),
        title: 'phone',
    },
];

export const DESKTOP_INSTRUMENTS = [
    {
        icon: MyAccount,
        iconWidth: 14,
        strokeWidth: 2,
        text: (
            <>
                Log in to your <br />
                account
            </>
        ),
        title: 'login',
    },
    {
        icon: RulerMini,
        iconWidth: 28,
        strokeWidth: 1.5,
        text: (
            <>
                10+ ft. of
                <br />
                well-lit space
            </>
        ),
        title: 'space',
    },
    {
        icon: MobileDesktop,
        iconWidth: 33,
        strokeWidth: 1.5,
        text: (
            <>
                A mobile or
                <br />
                desktop device
            </>
        ),
        title: 'phone',
    },
];
